export const PAGE_CONFIG = {
  title: 'Retention',
  titleCN: '留存',
  subTitle: '',
  subTitleCN: '',
  path: '/retention/nightingale',
  defaultTab: 'returnNewUsers',
  tabList: [
    {
      id: 'returnNewUsers',
      tabName: 'Return Rate -New Users',
      tabNameCN: '新进用户留存率',
      isHaveNotification: true,
      notificationPath: '/retention/nightingale/returnNewUsers',
      path: '/retention/nightingale/returnNewUsers',
      logConfig: {
        pageId: '203301',
        pageName: 'returnNewUsers',
        extInfo: 'returnNewUsers',
        pagePath: '/retention/nightingale/returnNewUsers',
      },
      filters: [
        {
          name: 'RetentionNightingaleFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/returnNewUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/retention/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Return Rate -New Users',
                  titleCN: '新进用户次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'New Users Retention',
                  cnChartTooltipsName: '新进用户留存',
                }
              },
              data: {
                tag: 'new',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'New',
                      cnName: '注册',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },

                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Return Rate -New Users',
                  titleCN: '新进用户留存率',
                }
              },
              data: {
                tag: 'new',
                retentionColumsNum:'1'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'returnActiveUsers',
      tabName: 'Return Rate -Active Users',
      tabNameCN: '活跃用户留存率',
      isHaveNotification: true,
      notificationPath: '/retention/nightingale/returnActiveUsers',
      path: '/retention/nightingale/returnActiveUsers',
      logConfig: {
        pageId: '203302',
        pageName: 'returnActiveUsers',
        extInfo: 'returnActiveUsers',
        pagePath: '/retention/nightingale/returnActiveUsers',
      },
      filters: [
        {
          name: 'RetentionNightingaleFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/returnActiveUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/retention/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Return Rate -Active Users',
                  titleCN: '活跃用户次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'Active Users Retention',
                  cnChartTooltipsName: '活跃用户留存',
                }
              },
              data: {
                tag: 'active',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'Active Users',
                      cnName: '活跃用户',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Return Rate -Active Users',
                  titleCN: '活跃用户留存率',
                }
              },
              data: {
                tag: 'active',
                retentionColumsNum:'1'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'rollingNewUsers',
      tabName: 'Rolling Retention -New Users',
      tabNameCN: '新进用户滚动留存率',
      isHaveNotification: true,
      notificationPath: '/retention/nightingale/rollingNewUsers',
      path: '/retention/nightingale/rollingNewUsers',
      logConfig: {
        pageId: '203303',
        pageName: 'rollingNewUsers',
        extInfo: 'rollingNewUsers',
        pagePath: '/retention/nightingale/rollingNewUsers',
      },
      filters: [
        {
          name: 'RetentionNightingaleFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/rollingNewUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/retention/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Rolling Retention -New Users',
                  titleCN: '新进用户滚动次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'New Users Retention',
                  cnChartTooltipsName: '新进用户留存',
                }
              },
              data: {
                tag: 'new_rolling',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'New',
                      cnName: '注册',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Rolling Retention -New Users',
                  titleCN: '新进用户滚动留存率',
                }
              },
              data: {
                tag: 'new_rolling',
                retentionColumsNum:'1'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'rollingActiveUsers',
      tabName: 'Rolling Retention -Active Users',
      tabNameCN: '活跃用户滚动留存率',
      isHaveNotification: true,
      notificationPath: '/retention/nightingale/rollingActiveUsers',
      path: '/retention/nightingale/rollingActiveUsers',
      logConfig: {
        pageId: '203304',
        pageName: 'rollingActiveUsers',
        extInfo: 'rollingActiveUsers',
        pagePath: '/retention/nightingale/rollingActiveUsers',
      },
      filters: [
        {
          name: 'RetentionNightingaleFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/rollingActiveUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/retention/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Rolling Retention -Active Users',
                  titleCN: '活跃用户滚动次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'Active Users Retention',
                  cnChartTooltipsName: '活跃用户留存',
                }
              },
              data: {
                tag: 'active_rolling',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'Active Users',
                      cnName: '活跃用户',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Rolling Retention -Active Users',
                  titleCN: '活跃用户滚动留存率',
                }
              },
              data: {
                tag: 'active_rolling',
                retentionColumsNum:'1'
              }
            },
          ]
        },
      ],
    },
  ],
}